import { type BreadcrumbType } from "@bugsnag/js";

import bugsnag from "./bugsnagClient";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function error(message: any, metaData?: any) {
  console.error(message);

  if (bugsnag) {
    bugsnag.notify(normalizeMessage(message), (event) => {
      event.severity = "error";
      event.addMetadata("metaData", metaData);
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function warning(message: any, metaData?: any) {
  console.warn(message);

  if (bugsnag) {
    bugsnag.notify(normalizeMessage(message), (event) => {
      event.severity = "warning";
      event.addMetadata("metaData", metaData);
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function info(message: any, metaData?: any) {
  console.info(message);

  if (bugsnag) {
    bugsnag.notify(normalizeMessage(message), (event) => {
      event.severity = "info";
      event.addMetadata("metaData", metaData);
    });
  }
}

export function breadcrumb(
  name: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metaData?: any,
  type?: BreadcrumbType
) {
  if (bugsnag) {
    bugsnag.leaveBreadcrumb(name, metaData, type);
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalizeMessage(message: any): string | Error {
  if (message instanceof Error) {
    return message;
  }

  if (typeof message === "object") {
    return (
      message.error_description ||
      message.error ||
      message.message ||
      JSON.stringify(message)
    );
  }

  return message.toString();
}
